import { c as _c } from "react/compiler-runtime";
import { GetStaticProps } from 'next';
import { Roots } from 'next-roots/context';
import OSkippayRoot, * as __root from 'roots/o-skippay';
function OSkippayPage(pageProps) {
  const $ = _c(2);
  let t0;
  if ($[0] !== pageProps) {
    t0 = <OSkippayRoot {...pageProps} />;
    $[0] = pageProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
OSkippayPage.getRoots = (): Partial<Roots> => ({
  currentLocale: 'sk',
  currentRoot: 'o-skippay',
  currentRule: {
    "key": "sk:o-skippay",
    "href": "/o-skippay"
  },
  currentMeta: {
    "key": "sk:o-skippay",
    "data": {}
  },
  rules: [{
    "key": "sk:home",
    "href": "/"
  }, {
    "key": "sk:cenik",
    "href": "/cennik"
  }, {
    "key": "sk:chci-aplikaci",
    "href": "/chcem-aplikaciu"
  }, {
    "key": "sk:css-program",
    "href": "/css-program"
  }, {
    "key": "sk:dokumenty/index",
    "href": "/dokumenty"
  }, {
    "key": "sk:dokumenty/generated/informacni-memorandum",
    "href": "/dokumenty/generated/informacne-memorandum"
  }, {
    "key": "sk:dokumenty/generated/post",
    "href": "/dokumenty/generated/[post]"
  }, {
    "key": "sk:doporucte-nas",
    "href": "/doporucte-nas"
  }, {
    "key": "sk:dobirka",
    "href": "/dobirka"
  }, {
    "key": "sk:dotaznik",
    "href": "/dotaznik"
  }, {
    "key": "sk:informacni-memorandum",
    "href": "/informacne-memorandum"
  }, {
    "key": "sk:investuj-pri-nakupovani",
    "href": "/investuj-pri-nakupovani"
  }, {
    "key": "sk:jak-zaplatit",
    "href": "/jak-zaplatit"
  }, {
    "key": "sk:kariera/index",
    "href": "/kariera"
  }, {
    "key": "sk:kariera/volne-pozice",
    "href": "/kariera/volne-pozice"
  }, {
    "key": "sk:kariera/detail",
    "href": "/kariera/[job]"
  }, {
    "key": "sk:caste-dotazy/index",
    "href": "/casto-kladene-otazky"
  }, {
    "key": "sk:caste-dotazy/category",
    "href": "/casto-kladene-otazky/[category]"
  }, {
    "key": "sk:caste-dotazy/question",
    "href": "/casto-kladene-otazky/[category]/[question]"
  }, {
    "key": "sk:karta",
    "href": "/karta"
  }, {
    "key": "sk:kde-nakupovat",
    "href": "/kde-nakupovat"
  }, {
    "key": "sk:kontakty",
    "href": "/kontakty"
  }, {
    "key": "sk:kontokorent",
    "href": "/kontokorent"
  }, {
    "key": "sk:kreditni-karta",
    "href": "/kreditni-karta"
  }, {
    "key": "sk:kurzovni-listek",
    "href": "/kurzovni-listek"
  }, {
    "key": "sk:mallpay",
    "href": "/mallpay"
  }, {
    "key": "sk:mobilni-aplikace",
    "href": "/mobilna-aplikacia"
  }, {
    "key": "sk:nase-produkty",
    "href": "/nase-produkty"
  }, {
    "key": "sk:nakup-na-splatky",
    "href": "/nakup-na-splatky"
  }, {
    "key": "sk:nakup-na-tretinu",
    "href": "/nakup-na-tretinu"
  }, {
    "key": "sk:nakupujte-s-rozumem",
    "href": "/nakupujte-s-rozumem"
  }, {
    "key": "sk:napsali-o-nas",
    "href": "/napsali-o-nas"
  }, {
    "key": "sk:nastaveni-soukromi",
    "href": "/nastavenie-sukromia"
  }, {
    "key": "sk:o-skippay",
    "href": "/o-skippay"
  }, {
    "key": "sk:odhlaseni-novinek/token",
    "href": "/odhlasenie-noviniek/[token]"
  }, {
    "key": "sk:odlozena-platba",
    "href": "/odlozena-platba"
  }, {
    "key": "sk:odlozeni-splatnosti",
    "href": "/odlozeni-splatnosti"
  }, {
    "key": "sk:odmeny",
    "href": "/odmeny"
  }, {
    "key": "sk:openapi",
    "href": "/openapi"
  }, {
    "key": "sk:partneri",
    "href": "/partneri"
  }, {
    "key": "sk:ostatni-dokumenty",
    "href": "/ostatne-dokumenty"
  }, {
    "key": "sk:platba-kartou",
    "href": "/platba-kartou"
  }, {
    "key": "sk:platba-online",
    "href": "/platba-online"
  }, {
    "key": "sk:platba-skip-pay",
    "href": "/platba-skip-pay"
  }, {
    "key": "sk:platebni-brana",
    "href": "/platebni-brana"
  }, {
    "key": "sk:pojisteni/index",
    "href": "/pojisteni"
  }, {
    "key": "sk:pojisteni/pojistne-podminky",
    "href": "/pojisteni/pojistne-podminky"
  }, {
    "key": "sk:pojisteni-ke-karte",
    "href": "/pojisteni-ke-karte"
  }, {
    "key": "sk:prevod-penez",
    "href": "/prevod-penez"
  }, {
    "key": "sk:pro-eshop",
    "href": "/pre-eshop"
  }, {
    "key": "sk:pro-novinare",
    "href": "/pre-novinarov"
  }, {
    "key": "sk:pro-vyvojare",
    "href": "/pre-vyvojarov"
  }, {
    "key": "sk:prodlouzena-zaruka",
    "href": "/prodlouzena-zaruka"
  }, {
    "key": "sk:pujcka",
    "href": "/pujcka"
  }, {
    "key": "sk:pujcky",
    "href": "/pujcky"
  }, {
    "key": "sk:recenze-klientu",
    "href": "/recenze-klientu"
  }, {
    "key": "sk:balicek-maxi",
    "href": "/balicek-maxi"
  }, {
    "key": "sk:slevy/index",
    "href": "/slevy"
  }, {
    "key": "sk:slevy/category",
    "href": "/slevy/kategorie/[category]"
  }, {
    "key": "sk:slevy/eshop",
    "href": "/slevy/[eshop]"
  }, {
    "key": "sk:splatky",
    "href": "/splatky"
  }, {
    "key": "sk:srovnavac-produktu/index",
    "href": "/srovnavac-produktu"
  }, {
    "key": "sk:srovnavac-produktu/vyhledavani",
    "href": "/srovnavac-produktu/vyhledavani"
  }, {
    "key": "sk:srovnavac-produktu/category",
    "href": "/srovnavac-produktu/[category]"
  }, {
    "key": "sk:srovnavac-produktu/subcategoryLevelOne",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]"
  }, {
    "key": "sk:srovnavac-produktu/subcategoryLevelTwo",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]"
  }, {
    "key": "sk:srovnavac-produktu/subcategoryLevelThree",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]"
  }, {
    "key": "sk:srovnavac-produktu/subcategoryLevelFour",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]/[subcategoryLevelFour]"
  }, {
    "key": "sk:srovnavac-produktu/subcategoryLevelFive",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]/[subcategoryLevelFour]/[subcategoryLevelFive]"
  }, {
    "key": "sk:srovnavac-produktu/subcategoryLevelSix",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]/[subcategoryLevelFour]/[subcategoryLevelFive]/[subcategoryLevelSix]"
  }, {
    "key": "sk:sprava-osobnich-udaju/index",
    "href": "/sprava-osobnych-udajov"
  }, {
    "key": "sk:sprava-osobnich-udaju/token",
    "href": "/sprava-osobnych-udajov/[token]"
  }, {
    "key": "sk:tiskove-zpravy/index",
    "href": "/tiskove-zpravy"
  }, {
    "key": "sk:tiskove-zpravy/pressRelease",
    "href": "/tiskove-zpravy/[pressRelease]"
  }, {
    "key": "sk:uvitaci-video",
    "href": "/uvitaci-video"
  }, {
    "key": "sk:vseobecne-obchodni-podminky",
    "href": "/vseobecne-obchodne-podmienky"
  }, {
    "key": "sk:whistleblowing",
    "href": "/whistleblowing"
  }, {
    "key": "sk:zaplatim-po-vanocich",
    "href": "/zaplatim-po-vanocich"
  }, {
    "key": "sk:my-to-platime",
    "href": "/my-to-platime"
  }, {
    "key": "sk:zruseni-skip-pay",
    "href": "/zruseni-skip-pay"
  }, {
    "key": "sk:vraceni-preplatku/index",
    "href": "/vraceni-preplatku"
  }, {
    "key": "sk:vraceni-preplatku/token",
    "href": "/vraceni-preplatku/[token]"
  }, {
    "key": "sk:hlaseni-skody",
    "href": "/hlaseni-skody"
  }, {
    "key": "cs:o-skippay",
    "href": "/cs/o-skippay"
  }, {
    "key": "sk:o-skippay",
    "href": "/o-skippay"
  }, {
    "key": "hu:o-skippay",
    "href": "/hu/about-skippay"
  }],
  meta: [{
    "key": "cs:o-skippay",
    "data": {}
  }, {
    "key": "sk:o-skippay",
    "data": {}
  }, {
    "key": "hu:o-skippay",
    "data": {}
  }]
});

// @ts-ignore
export const getStaticProps: GetStaticProps = async context => __root.getStaticProps({
  ...context,
  __locale: 'sk'
});
export default OSkippayPage;